// extracted by mini-css-extract-plugin
module.exports = {"button-arrow":"styles_button-arrow__MgSaq","inner":"styles_inner__qy01M","expand":"styles_expand__cprHD"};